module.exports = "<div id=\"spinner\" class=\"block-ui-template\">\n\n    <div class=\"block-ui-overlay\"></div>\n    <div class=\"block-ui-message-container\" aria-live=\"assertive\" aria-atomic=\"true\">\n        <div class=\"loader\"><span></span><span></span><span></span></div>\n        <div class=\"loader-text\">{{message}}</div>   \n    </div>\n\n\n</div>"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/shared/spiner/spiner.component.html
// module id = ./src/app/components/shared/spiner/spiner.component.html
// module chunks = main